import { Typography } from "@mui/material";

export const DoubleDot = () => {
  return (
    <Typography variant="footnotes" sx={{
      display: "inline",
      fontSize: "inherit",
      fontWeight: "900",
      ml: 0.1,
      mb: 0.5
    }}>:</Typography>
  );
};
